import { render, staticRenderFns } from "./BannersTab.vue?vue&type=template&id=6d794c9b&scoped=true&"
import script from "./BannersTab.vue?vue&type=script&lang=js&"
export * from "./BannersTab.vue?vue&type=script&lang=js&"
import style0 from "./BannersTab.vue?vue&type=style&index=0&id=6d794c9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d794c9b",
  null
  
)

export default component.exports